import { EmailInterface, EmailState } from '../../models/state';
import { actionTypes } from '../actions/email';

const initialState: EmailState = {
  email: {} as EmailInterface,
  emails: [],
  emailCount: 0,
};
const emailReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_EMAILS_SUCCESS: {
      return {
        ...state,
        emails: action.payload.rows,
        emailCount: action.payload.count,
      };
    }
    case actionTypes.GET_EMAIL_BY_ID_SUCCESS: {
      return {
        ...state,
        email: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default emailReducer;
